"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _overview = _interopRequireDefault(require("../overview"));

var _filters = require("../overview/filters/filters");

var _EmptyPage = _interopRequireDefault(require("../../preact-components/empty-page/EmptyPage"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _FormatCell = _interopRequireDefault(require("../overview/cells/FormatCell"));

var _InviteStatusCell = _interopRequireDefault(require("../overview/cells/InviteStatusCell"));

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var _inviteContact = _interopRequireDefault(require("../overview/bulk-actions/inviteContact"));

var ContactOverview = function ContactOverview() {
  function getFilters() {
    return [(0, _filters.userTag)()];
  }

  function getColumns() {
    return [{
      header: 'Email address',
      accessor: 'email'
    }, {
      header: 'Name',
      accessor: 'name'
    }, {
      header: 'User tags',
      accessor: 'userTags',
      cell: (0, _FormatCell.default)('userTags', function (arr) {
        return arr.join(',');
      })
    }, {
      header: 'Invite status',
      accessor: 'invite',
      cell: (0, _InviteStatusCell.default)()
    }];
  }

  function getBulkActions() {
    return [_inviteContact.default];
  }

  return (0, _preact.h)(_overview.default, {
    type: "contact",
    headerTitle: "Contact Overview",
    headerButtons: [(0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)("/contact/import"),
      key: "import-contacts"
    }, (0, _preact.h)(_buttonControl.default, {
      title: "Import contacts via csv",
      variant: "brand",
      newStyle: true,
      size: "medium"
    }))],
    withPagination: {
      page: 1,
      pageSize: 25
    },
    withFilters: getFilters(),
    withSearch: true,
    searchPlaceholder: "Search contacts",
    rowId: "id",
    model: getColumns(),
    endpoint: "/contact/contacts",
    dataKey: "contacts",
    bulkActions: getBulkActions(),
    EmptyStateComponent: (0, _preact.h)(_EmptyPage.default, {
      img_src: "".concat((0, _globals.default)('defaultCdn'), "/images/empty_page.png"),
      header: "There are no contacts yet",
      text: 'Seems like no one on your team has imported contacts. \n Start now by importing contacts.',
      button: {
        link: '/contact/import',
        text: 'Import contacts'
      }
    })
  });
};

var _default = ContactOverview;
exports.default = _default;